import '../App.css';
import React, { useCallback, useEffect, useState } from 'react';
import { Magic } from 'magic-sdk';
import { OAuthExtension } from '@magic-ext/oauth';
import { PAGES } from '../constants/Pages';
import { useLoginWithToken } from '../hooks/useUser/useLoginWithToken';

function AuthenticationToken() {
  const magic = new Magic(`${process.env.REACT_APP_MAGIC_LINK}`, { extensions: [new OAuthExtension()] });
  const [activeLoader, setActiveLoader] = useState(true);
  const { loginWithToken } = useLoginWithToken();

  const generateUniqueState = () => {
    const randomString = Math.random().toString(36).substring(2, 15);
    const timestamp = new Date().getTime().toString();
    return randomString + timestamp;
  };

  const getLoginResult = useCallback(async () => {
    try {
      const state = generateUniqueState();
      const authUrl = magic.oauth.getAuthorizationUrl({ state });
      window.location.href = authUrl;
    } catch (error) {
      console.error('Error generating unique state:', error);
    }
  }, [magic.oauth]);

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        const result = await magic.oauth.getRedirectResult();
        const { idToken } = result.magic;
        // Call loginWithToken and handle the response
        const loginResponse = await loginWithToken(idToken);
        // Handle successful login...  
      } catch (error) {
        console.error('Error during redirect result:', error);
        // Handle error accordingly, for example, redirect to an error page or show a message
        // window.location.href = `/error`;
      }
    };

    handleRedirect();
  }, [magic.oauth, loginWithToken]);

  // useEffect(() => {
  //   const handleRedirect = async () => {
  //     try {
  //       const result = await magic.oauth.getRedirectResult();
  //       const { idToken } = result.magic;
  //       const { defaultPage, token } = await loginWithToken(idToken);
  //       if(token){
  //         localStorage.setItem('TOKEN', token);
  //         localStorage.setItem('ISLOGIN', 'true');
  //         localStorage.setItem('EMAIL', result.magic.userMetadata.email);
  //         window.location.href = `/${PAGES.UPLOADERSCREEN}`;
  //       }
  //       else{
  //         window.location.href = `/`;
  //       }

  //     } catch (error) {
  //       console.error('Error during redirect result:', error);
  //       if(error.message.includes('WRONG_EMAIL')){
  //         window.location.href = `/?status=failureMsg`;
  //       } 
  //     }
  //   };

  //   handleRedirect();
  // }, [magic.oauth, loginWithToken]);

  return (
    <div
      className={
        activeLoader === true ? "CommetsLoader active" : "CommetsLoader"
      }
    ></div>
  );
}

export default AuthenticationToken;
